<template>
    <b v-if="isRequired" class="required">*</b>
</template>

<script>
export default {
    name: 'oc-required-column-after-column',
    inject: ['$source'],
    props: {
        title : {},
        field: {},
        required: {
            default: null // from table-cell $attrs
        }
    },
    computed: {
        isRequired() {
            return this.required !== false && (this.$source.requiredColumns.indexOf(this.field) > - 1 || this.required === true)
        }
    }
}
</script>

<style scoped>
.required {color: red;}
</style>
